<template>

    <v-text-field
      solo-inverted
      v-model.trim="searchText"
      @change="searchTextChange"
      text
      label="Search"
      ref="searchbox"
    >
    <template v-slot:prepend-inner>
      <v-icon v-if="searchIcon" :small="smallIcon">{{ searchIcon }}</v-icon>
    </template>
  </v-text-field>


</template>
<script>
import { Controls, updateControls } from '@/gql'
import { settings } from '@/js/store'
export default {
  name: 'app-search',
  computed: {
    searchIcon () {
      return this.$vuetify.breakpoint.smAndUp ? 'search' : ''
    },
    smallIcon () {
      return this.$vuetify.breakpoint.smAndDown
    },
    iconSize () {
      return this.smallIcon ? settings.dimensions.blobIconSm : settings.dimensions.blobIconNormal
    },
    loading () {
      return this.$apollo.loading
    }
  },
  methods: {
    mutate (mutation, variables) {
      this.$apollo.mutate({ mutation, variables })
    },
    searchTextChange (value) {
      if (this.$refs.searchbox) {
        this.$refs.searchbox.blur()
      }
      return this.updateProperty('searchText', value.trim())
    },
    updateProperty (key, value) {
      return this.mutate(updateControls, {
        key,
        value
      })
    }
  },
  data: () => ({
    Controls: {},
    searchText: ''
  }),
  apollo: {
    Controls: {
      query: Controls,
      result (result) {
        const controls = result && result.data && result.data.Controls
        if (controls) {
          this.searchText = controls.searchText
        }
        this.Controls = controls
      }
    }
  }
}

</script>
